// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Vk0+G","text-container":"styles_text-container__8yFcs"};